import React from 'react';

const XLoadingSpinner: React.FC = () => (
	<div className="spinner-container" data-testid="loading-spinner">
		<div className="spinner"></div>
	</div>
);

export default XLoadingSpinner;
